import React from 'react';
import { Form, Icon, Input, Radio, Select } from 'antd';
import Signature from "./Signature";

const { Option } = Select;

export default class extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;
    const showForEmail = !(props.consentMethodType === 'EmailRegainedCapacity' && !props.token);

    return (
      <div className="form-group">
        <div className="form-group-details">
          <h4>Consent Process - REGAINED CAPACITY CONSENT FORM</h4>

          {props.siteID && <h5>Site ID: <b>{props.siteID}</b></h5>}
          {props.userID && <h5>User ID: <b>{props.userID}</b></h5>}
          <h5>Subject ID: <b>{props.subjectID}</b></h5>
        </div>
        <div style={{ textAlign: 'left' }}>
          {props.has_randomization_platform_step_3_patient_regained_capacity ? <div
              dangerouslySetInnerHTML={{__html: props.randomization_platform_step_3_patient_regained_capacity_content}}/> :
            <div style={{textAlign: 'center'}}>
              <p><i>REGAINED CONSENT FORM NOT LOADED</i></p>
            </div>}
        </div>
        <p><strong>Server Date (UTC): {props.consentDate || props.date}</strong></p>
        <p><strong>Consent Type: {props.consentPersonType}</strong></p>
        <p><strong>Consent Method: {props.consentMethodType}</strong></p>
        <p>&nbsp;</p>


        <h4>REGAINED CAPACITY CONSENT FORM</h4>
        <div style={{ textAlign: 'left' }}>

          {showForEmail && <div>
            <p>Informed consent is essential throughout a research project. This means in your
              situation, you are now being given the opportunity to agree or disagree with the
              decision made by your surrogate to stay in the trial for ongoing data collection. The
              administration of either Alteplase or Tenecteplase cannot be undone. Any information
              that was obtained when the researchers were acting on your surrogate’s consent for
              your involvement will remain part of the study, but it is now your choice whether to
              continue or not. If you decide not to consent, data collected up until this point
              will be retained. You will not be contacted in future. You may also withdraw consent
              for further contact but continue follow-up via health record linkage.</p>

            <Form.Item>
              <label>
                <div className='form-label'>Please check the appropriate box to indicate your decision:</div>
                {props.form.getFieldDecorator('rccf_consent_option', {
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group>
                    <Radio value='stay_in_study'>
                      I wish to stay in the study.
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study'>
                      I wish to withdraw from the study.
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study_allow_data_collection_via_linkage'>
                      I wish to withdraw from the study but allow my data to be collected from this point onward via health record linkage.
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>
          </div>}

          <h4>SIGNATURES</h4>
          <div>
            <p>
              Your signature on this form indicates that you have understood to your satisfaction the information regarding the patient’s participationin the research project and agree for the patient to participate as a participant. In no way does this waive the patient’slegal rights nor release the investigators or involved institutions from their legal and professional responsibilities. You are freeto withdrawthe patient fromthe study at any time without jeopardizing your health care.If you have further questions concerning matters related to this research, please contact:
            </p>

            <p style={{ textAlign: 'center' }}>Dr. Herbert Alejandro Manosalva A. (403) 529-8810 <br/> or <br/> the Stroke Research office (403) 944-4286</p>
            <p>If you have any questions concerning your rights as a possible participant in this research, please contact the Chair, Conjoint Health Research Ethics Board,at the University of Calgary at 403-220-7990.</p>
            <br/><br/>
          </div>

          <Form.Item>
            <label>
              <div className='form-label'>Participant Name</div>
              {props.form.getFieldDecorator('rccf_participant_name', {
                initialValue: props.rccf_participant_name,
                rules: [{
                  required: true,
                  message: 'Required'
                }],
              })(
                <Input
                  prefix={<Icon type="user" style={{color: '#eee'}}/>}
                  placeholder="Participant Name"
                />
              )}
            </label>
          </Form.Item>

          {props.consentMethodType === 'EmailRegainedCapacity' && <Form.Item>
            {props.form.getFieldDecorator('rccf_participant_email', {
              initialValue: props.rccf_participant_email,
              rules: [{required: true, message: 'Please enter the participant\'s email'}, {type: 'email'}],
            })(
              <Input disabled={props.token} placeholder="Participant Email"/>
            )}
          </Form.Item>}

          {props.consentPersonType === 'Patient' && showForEmail  && (
            <div>
              <Signature fieldName='rccf_participant_signature' label='Signature of Participant' form={props.form} />
            </div>
          )}

          <div>
            <Form.Item>
              <label>
                <div className='form-label'>Investigator/Delegate’s Name</div>
                {props.form.getFieldDecorator('rccf_investigator_name', {
                  initialValue: props.rccf_investigator_name,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Input
                    disabled={props.token}
                    prefix={<Icon type="user" style={{color: '#eee'}}/>}
                    placeholder="Investigator/Delegate’s Name"
                  />
                )}
              </label>
            </Form.Item>

            {!props.token && <Signature fieldName='rccf_investigator_signature' label='Signature of Investigator/Delegate’s' form={props.form} />}
          </div>

          {showForEmail && !props.token && <div>

            <div>
              <Form.Item>
                <label>
                  <div className='form-label'>Witness’ Name</div>
                  {props.form.getFieldDecorator('mtl_rccf_consent_witness_name_and_relationship', {
                    initialValue: props.mtl_rccf_consent_witness_name_and_relationship,
                  })(
                    <Input
                      prefix={<Icon type="user" style={{color: '#eee'}}/>}
                      placeholder="Witness Name"
                    />
                  )}
                </label>
              </Form.Item>

              {props.form.getFieldValue('mtl_rccf_consent_witness_name_and_relationship') && <Signature fieldName='mtl_rccf_consent_witness_signature' label='Signature of Witness' form={props.form} optional={false} />}
            </div>
            <br/>
            <br/>
          </div>}

          {showForEmail && <Form.Item>
            <label>
              <div className='form-label'>Do you consent to the terms described above?</div>
              {props.form.getFieldDecorator('consent_provided', {
                initialValue: props.consent_provided,
                rules: [{
                  required: true,
                  message: 'Do you consent to the terms described above?'
                }],
              })(
                <Select>
                  <Option value="yes">Yes</Option>
                  <Option value="">No</Option>
                </Select>
              )}
            </label>
          </Form.Item>}

          <p>The University of Calgary Conjoint Health Research Ethics Board has approved this research study. A signed copy of this consent form has been given to you for your records and reference.</p>

        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConsentTypeMedicineHat/Step3aRegainedCapacity.js